const BASE_URL = process.env.REACT_APP_BASE_URL;

// AUTH ENDPOINTS
export const endpoints = {
  SIGNUP_API: BASE_URL + "/auth/signup",
  EMPLOYEESIGNUP_API: BASE_URL + "/employee/signup",
  LOGIN_API: BASE_URL + "/auth/login",
  RESETPASSTOKEN_API: BASE_URL + "/auth/reset-password-token",
  RESETPASSWORD_API: BASE_URL + "/auth/reset-password",
  REFRESH_TOKEN_API: BASE_URL + "/auth/refresh-token",
  LOGOUT_API: BASE_URL + "/auth/logout",
};

// PROFILE ENDPOINTS
export const profileEndpoints = {
  GET_USER_DETAILS_API: BASE_URL + "/profile/getUserDetails",
  GET_USER_ENROLLED_NODES_API: BASE_URL + "/profile/getNodes",
  ADMIN_DASHBOARD_API: BASE_URL + "/profile/adminDashboard",
};

// CONTACT-US API
export const contactusEndpoint = {
  CONTACT_US_API: BASE_URL + "/reach/contact",
};

// SETTINGS PAGE API
export const settingsEndpoints = {
  UPDATE_DISPLAY_PICTURE_API: BASE_URL + "/profile/updateDisplayPicture",
  UPLOAD_PICTURE_API: BASE_URL + "/profile/uploadPicture",
  UPDATE_PROFILE_API: BASE_URL + "/profile/updateProfile",
  CHANGE_PASSWORD_API: BASE_URL + "/auth/changepassword",
  DELETE_PROFILE_API: BASE_URL + "/profile/deleteProfile",
};

// NODE APIs
export const nodeEndpoints = {
  CREATE_NODE_API: `${BASE_URL}/node/create`,
  GET_NODES_BY_DRAWINGSHEET_API: (drawingSheetId) => `${BASE_URL}/node/drawingSheet/${drawingSheetId}`,
  GET_SINGLE_NODE_API: (nodeId) => `${BASE_URL}/node/${nodeId}`,
  DELETE_NODE_API: (nodeId) => `${BASE_URL}/node/${nodeId}`,
  MARK_NODE_COMPLETE_API: (nodeId) => `${BASE_URL}/node/${nodeId}/mark-complete`,
  GET_EMPLOYEE_TASK_API: `${BASE_URL}/node/assigned-tasks`,   // ✅ Added
};

// WORKSHEET APIs
export const worksheetEndpoints = {
  CREATE_WORKSHEET_API: `${BASE_URL}/worksheet/create`,
  GET_WORKSHEETS_BY_NODE_API: (nodeId) => `${BASE_URL}/worksheet/node/${nodeId}`,
  GET_SINGLE_WORKSHEET_API: (worksheetId) => `${BASE_URL}/worksheet/${worksheetId}`,
  DELETE_WORKSHEET_API: (worksheetId) => `${BASE_URL}/worksheet/${worksheetId}`,
  UPDATE_WORKSHEET_API: (worksheetId) => `${BASE_URL}/worksheet/update/${worksheetId}`,
  GET_ADMIN_NODE_WORKSHEETS_API: (nodeId) => `${BASE_URL}/worksheet/admin/node/${nodeId}`,
  GET_SUGGESTIONS: `${BASE_URL}/worksheet/ai-suggestions`,
  GET_AI_SUGGESTIONS_API : `${BASE_URL}/worksheet/getAISuggestions`
};


// ADMIN APIs
export const adminEndpoints = {
  CREATE_EMPLOYEE_INVITE_API: `${BASE_URL}/admin/invite`,
  DELETE_ADMIN_ACCOUNT_API: `${BASE_URL}/admin/delete`,
  REMOVE_EMPLOYEE_API: (employeeId) => `${BASE_URL}/admin/remove-employee/${employeeId}`,
  GET_DRAWINGSHEETS_API: `${BASE_URL}/drawingsheet/mydrawingsheets`,
  GET_DRAWINGSHEET_TEAM_API: (drawingSheetId) => `${BASE_URL}/drawingsheet/${drawingSheetId}/team`,
  GET_ALL_DRAWINGS_API: `${BASE_URL}/admin/get-all-drawingsheets`,   // ✅ Added for Admin Dashboard
  GET_INVITED_EMPLOYEES_API: `${BASE_URL}/admin/get-invited-employees`,  // ✅ Added for Remove Employee Page
  GET_ADMIN_DASHBOARD_DATA_API: `${BASE_URL}/admin/dashboard-data`,
  GET_EMPLOYEE_ASSIGNED_TASK_API: (employeeId) => `${BASE_URL}/admin/employee-tasks/${employeeId}`,
  GET_MY_TEAMS_API: `${BASE_URL}/admin/get-my-teams`
};

// DRAWINGSHEET APIs
export const drawingSheetEndpoints = {
  CREATE_DRAWINGSHEET_API: `${BASE_URL}/drawingsheet/create`,
  GET_ALL_DRAWINGSHEETS_API: `${BASE_URL}/drawingsheet/mydrawingsheets`,
  GET_SINGLE_DRAWINGSHEET_API: (id) => `${BASE_URL}/drawingsheet/${id}`,
  DELETE_DRAWINGSHEET_API: (id) => `${BASE_URL}/drawingsheet/${id}`,
  GET_ASSIGNED_DRAWINGS_API: `${BASE_URL}/drawingsheet/drawings/assigned`,  // ✅ Added for Employee Dashboard
  GET_ADMIN_DRAWING_SHEET: `${BASE_URL}/drawingsheet/admin/drawings`,
  MARK_COMPLETED_DRAWING_API: `${BASE_URL}/drawingsheet/completed`,
};

export const hazopEndpoints = {
  CREATE_WORKSHEET_API: BASE_URL + "/worksheet/create",
  GET_WORKSHEETS_BY_NODE_API: BASE_URL + "/worksheet/node",
  UPDATE_WORKSHEET_API: BASE_URL + "/worksheet/update",
  DELETE_WORKSHEET_API: BASE_URL + "/worksheet/delete",
  GET_AI_SUGGESTION_API: BASE_URL + "/worksheet/ai-suggestion",
  GENERATE_AI_HAZOP_API: BASE_URL + "/ai/generate-hazop",
}






// const BASE_URL = process.env.REACT_APP_BASE_URL;

// // AUTH ENDPOINTS
// export const endpoints = {
//   SIGNUP_API: BASE_URL + "/auth/signup",
//   EMPLOYEESIGNUP_API: BASE_URL + "/employee/signup",
//   LOGIN_API: BASE_URL + "/auth/login",
//   RESETPASSTOKEN_API: BASE_URL + "/auth/reset-password-token",
//   RESETPASSWORD_API: BASE_URL + "/auth/reset-password",
// };

// // PROFILE ENDPOINTS
// export const profileEndpoints = {
//   GET_USER_DETAILS_API: BASE_URL + "/profile/getUserDetails",
//   GET_USER_ENROLLED_NODES_API: BASE_URL + "/profile/getNodes",
//   ADMIN_DASHBOARD_API: BASE_URL + "/profile/adminDashboard",
// };

// // CONTACT-US API
// export const contactusEndpoint = {
//   CONTACT_US_API: BASE_URL + "/reach/contact",
// };

// // SETTINGS PAGE API
// export const settingsEndpoints = {
//   UPDATE_DISPLAY_PICTURE_API: BASE_URL + "/profile/updateDisplayPicture",
//   UPDATE_PROFILE_API: BASE_URL + "/profile/updateProfile",
//   CHANGE_PASSWORD_API: BASE_URL + "/auth/changepassword",
//   DELETE_PROFILE_API: BASE_URL + "/profile/deleteProfile",
// };

// // NODE APIs
// export const nodeEndpoints = {
//   CREATE_NODE_API: `${BASE_URL}/node/create`,
//   GET_NODES_BY_DRAWINGSHEET_API: (drawingSheetId) => `${BASE_URL}/node/drawingSheet/${drawingSheetId}`,
//   GET_SINGLE_NODE_API: (nodeId) => `${BASE_URL}/node/${nodeId}`,
//   DELETE_NODE_API: (nodeId) => `${BASE_URL}/node/${nodeId}`,
//   MARK_NODE_COMPLETE_API: (nodeId) => `${BASE_URL}/node/${nodeId}/mark-complete`,
// };

// // WORKSHEET APIs
// export const worksheetEndpoints = {
//   CREATE_WORKSHEET_API: `${BASE_URL}/worksheet/create`,
//   GET_WORKSHEETS_BY_NODE_API: (nodeId) => `${BASE_URL}/worksheet/node/${nodeId}`,
//   GET_SINGLE_WORKSHEET_API: (worksheetId) => `${BASE_URL}/worksheet/${worksheetId}`,
//   DELETE_WORKSHEET_API: (worksheetId) => `${BASE_URL}/worksheet/${worksheetId}`,
//   GET_ADMIN_NODE_WORKSHEETS_API: (nodeId) => `${BASE_URL}/worksheet/admin/node/${nodeId}`,
// };

// // ADMIN APIs
// export const adminEndpoints = {
//   CREATE_EMPLOYEE_INVITE_API: `${BASE_URL}/admin/invite`,
//   DELETE_ADMIN_ACCOUNT_API: `${BASE_URL}/admin/delete`,
//   REMOVE_EMPLOYEE_API: (employeeId) => `${BASE_URL}/admin/remove-employee/${employeeId}`,
//   GET_DRAWINGSHEETS_API: `${BASE_URL}/drawingsheet/mydrawingsheets`,
//   GET_DRAWINGSHEET_TEAM_API: (drawingSheetId) => `${BASE_URL}/drawingsheet/${drawingSheetId}/team`,
// };

// // DRAWINGSHEET APIs
// export const drawingSheetEndpoints = {
//   CREATE_DRAWINGSHEET_API: `${BASE_URL}/drawingsheet/create`,
//   GET_ALL_DRAWINGSHEETS_API: `${BASE_URL}/drawingsheet/mydrawingsheets`,
//   GET_SINGLE_DRAWINGSHEET_API: (id) => `${BASE_URL}/drawingsheet/${id}`,
//   DELETE_DRAWINGSHEET_API: (id) => `${BASE_URL}/drawingsheet/${id}`,
// };
